import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-header',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './modal-header.component.html',
  styleUrl: './modal-header.component.scss',
})
export class ModalHeaderComponent {
  title = input<string | undefined>(undefined);
  showCloseButton = input<boolean>(true);
  closeClicked = output<void>();

  onClose(): void {
    this.closeClicked.emit();
  }
}
